import { render } from "./PageInit.vue?vue&type=template&id=7aa62cb9"
import script from "./PageInit.vue?vue&type=script&lang=js"
export * from "./PageInit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__